import type { FileUpload } from '@innermate/shared';

/**
 * ChatIndex → ChatSession 으로 첫 메시지를 넘기기 위한 간단한 in-memory 큐.
 * URL 검색 파라미터로 노출하지 않기 위해 모듈 스코프 Map 사용.
 */
interface PendingMessage {
  content: string;
  fileIds: string[];
  /** 단일 엔드포인트 세션. bondingId 와 상호배타. */
  endpointId?: string;
  /** 본딩 (가상 LLM) 세션. 서버가 매 메시지 랜덤 멤버를 선택한다. */
  bondingId?: string;
  extendedThinking?: boolean;
  /** Index 에서 사용자가 send 누른 시점(Date.now()). 응답 시간 실시간 표시 기준 시각. */
  startedAt?: number;
  /** Index 에서 업로드한 첨부 FileUpload 객체. Session 이 knownFiles 누적 맵에 merge 해 첫 턴 칩 표시. */
  files?: FileUpload[];
}

const pending = new Map<string, PendingMessage>();

export function setPendingMessage(
  sessionId: string,
  content: string,
  fileIds: string[] = [],
  extras: {
    endpointId?: string;
    bondingId?: string;
    extendedThinking?: boolean;
    startedAt?: number;
    files?: FileUpload[];
  } = {},
): void {
  pending.set(sessionId, { content, fileIds, ...extras });
}

export function takePendingMessage(sessionId: string): PendingMessage | null {
  const v = pending.get(sessionId);
  if (v === undefined) return null;
  pending.delete(sessionId);
  return v;
}
